import { useRef, useEffect } from 'react';
/**
 * @deprecated moved to marketplace-ui-common/hooks
 */

export const useMounted = () => {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted.current;
};